var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"dark":false}},[_c(_vm.layout,{tag:"component"},[_c('the-no-connection-modal'),_c('router-view'),_c('the-snackbar-loader')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }